<template>
    <div class="container">
        <mt-tabbar v-model="selected">
            <mt-tab-item id="/manageIndex">
                <img slot="icon" :src="require('../assets/img/mobileIndex.png')">
                首页
            </mt-tab-item>
            <mt-tab-item id="/weightSearch">
                <img slot="icon" :src="require('../assets/img/mobilePlan.png')">
                查询
            </mt-tab-item>
            <!-- id="/mobiledata" -->
            <mt-tab-item id="/weightReport">
                <img slot="icon" :src="require('../assets/img/mobileData.png')">
                报表
            </mt-tab-item>
            <mt-tab-item id="/manageMine">
                <img slot="icon" :src="require('../assets/img/mobileMine.png')">
                管理
            </mt-tab-item>
        </mt-tabbar>
    </div>
</template>

<script type="text/ecmascript-6">
import { Toast } from 'mint-ui';
export default {
    name: "mobileFooter",
    data() {
        return {
            selected: "/manageIndex",
        };
    },

    watch: {
        selected: function (val, oldVal) {
            this.$router.replace({
                name: val.substring(1),
            });
        },
        '$route': { // $route可以用引号，也可以不用引号  监听的对象
            handler(to, from) {
                this.selected = to.path
            },
            deep: true, // 深度观察监听 设置为 true
            immediate: true, // 第一次初始化渲染就可以监听到
        }
    },

    mounted() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    },
    methods: {
        clickID() {
            Toast({
                message: '暂未开启,敬请期待!',
                position: 'middle',
                duration: 2000
            });

        }
    },
};
</script>

<style scoped>
.mint-tabbar {
    position: fixed;
}

.mint-tabbar>.mint-tab-item.is-selected {
    color: #242424;
}
</style>


// WEBPACK FOOTER //
// src/components/mobileFooter.vue